import CommonHeader from '../pages/Head'
import React from 'react'
import axios from 'axios';
import { saveAs } from 'file-saver';


class NewApplication extends React.Component {	  
	constructor(props) {
		super(props);
		this.state = {ftpprocess:'', Appstatus:'IMPORT', user:localStorage.getItem('tokens')};	
		this.handleChange=this.handleChange.bind(this)		
		this.handleSubmit=this.handleSubmit.bind(this)
	}
	
	handleChange = event => {
		const {name, value} = event.target
		this.setState({[name]: value})  
		this.setState({Resp:''})
	}
	
	handleSubmit = event => {
		event.preventDefault()		
		const {ftpprocess} = this.state			
		if(!ftpprocess){
			alert('Please select FTP process')
			return false
		} 			
		const userObject = {	
			user:this.state.user,			
			Appstatus: this.state.Appstatus,
			ftpprocess: this.state.ftpprocess						
		};
		axios.post(process.env.REACT_APP_API_ENV+'api/approveprocess.php', userObject)
			.then((res) => {
				this.setState({Resp:res.data})											
			}).catch((error) => {
				console.log(error)
			});			

	}
	render() {		
		return(
			<div style={{textAlign:'center'}}>
				<CommonHeader titles="Payday Loan Application"/>			
				<label><b>Import Data</b></label><br/>
				<select name="ftpprocess" style={{width: '150px', border:'1px solid grey'}} value = {this.state.ftpprocess} onChange={this.handleChange}>
					<option value="">--Select--</option>
					<option value="1">Import Cashhub Data</option>
					<option value="2">Import PaySimplii Data</option>						
				</select><br/><br/>				
				{(()=>{if(this.state.ftpprocess !== "") {return (<div>	
					<form onSubmit={this.handleSubmit}>
						<label><b>Please click button to import {this.state.ftpprocess == "1" ? "Cashhub":"PaySimplii"} Data for FTP process</b></label><br/>						
						<h3>{this.state.Resp}</h3><br/><br/>
						<button className="btn btn-success btn-block" style={{fontSize:'150%'}}>Submit</button><br/><br/>
					</form>
				</div>)}})()}
			</div>
		)
	}
}

export default NewApplication